export const periodMap = [
  {
    label: 'periodsMap.alldates',
    value: 'all',
  },
  {
    label: 'periodsMap.today',
    value: 'today',
  },
  {
    label: 'periodsMap.yesterday',
    value: 'yesterday',
  },
  {
    label: 'periodsMap.thisweek',
    value: 'this_week',
  },
  {
    label: 'periodsMap.thismonth',
    value: 'this_month',
  },
];
